module.exports = __webpack_public_path__ + "static/media/lobby-concierge.8517a2fc.jpg";